module.exports = __webpack_public_path__ + "img/789.0abc7e08.png";